
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  getClaimDJ,
  getClaimDeductionInfo,
  getDeductionInfo,
} from "@/api/credit-note";

import { COMPANY_LIST } from "@/constant";
import { searchCustomer } from "@/api/customer";
@Component({
  name: "CreateClaim",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "其他费用" }) private title: "";
  @Prop({ default: "" }) private status: string;
  @Prop({ default: "" }) private hqPackingListId: string;
  @Prop({ default: "" }) private supplierId: string;
  @Prop({ default: true }) private getButtonTrue: boolean;
  private claimDJList = [] as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public props = { multiple: true, emitPath: false };
  private ChangeClaimCode = [] as any;

  private list = [
    {
      label: "公司",
      prop: "company",
      key: "company",
      type: "select",
      placeholder: "请选择公司",
      clearable: true,
      maxlength: 100,
      rules: {
        required: true,
        message: "请选择公司",
        trigger: "change",
      },
      options: COMPANY_LIST,
    },
    {
      label: "客户",
      prop: "customerId",
      key: "customerId",
      type: "select",
      value: "",
      placeholder: "请选择客户",
      remote: true,
      remote_method: this.getCustomer,
      clearable: true,
      options: [],
      rules: {
        required: true,
        message: "请选择客户",
        trigger: "change",
      },
      labelKey: "abbreviation",
      valueKey: "id",
    },
  ];

  private get canUpdate(): boolean {
    return this.status !== '在库'
        && this.status !== '部分出库'
        && this.status !== '出库待处置'
        && this.status !== '完全出库'
        && this.getButtonTrue;
  }

  created() {
    this.getClaimDJ();
    this.getDeductionInfo();
  }

  public loading: Boolean = false;

  private rowClassName({ row }) {
    return row.relationDocumentType === "PURCHASE_ORDER" ? "purchase-order-row" : "";
  }

  private isReadonlyRow(row) {
    return !this.canUpdate || row.relationDocumentType === "PURCHASE_ORDER";
  }

  public handleDeductionAmountChange(val, row) {
    const maxAmount = Number(row.unDeductedAmount) + Number(row.deductionAmountCopy);
    if (Number(val) > maxAmount) {
      row.deductionAmount = maxAmount;
      this.$notify({
        title: "提示",
        message: "抵扣金额输入错误！",
        type: "warning",
        duration: 2000
      });
    }
  }

  public async getClaimDJ() {
    let params = {
      type: 'HQ_PACKING_LIST',
      supplierId: this.supplierId
    }
    const res:any = await getClaimDJ(params)
    this.claimDJList = res
  }
  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.list[1].options = res;
  }
  private async getDeductionInfo() {
    this.loading = true;
    await getDeductionInfo(this.hqPackingListId).then((res:any) => {
      this.table.list = res;
      this.loading = false;
      this.table.list.map(e => {
        e.deductionAmountCopy = e.deductionAmount
      })
    }).catch(err => {
      console.log(err);
    });
  }
  //  删除
  public handleDelete(index: number) {
    const row = this.table.list[index];
    if (row && row.relationDocumentType === "PURCHASE_ORDER") {
      return;
    }
    this.table.list.splice(index, 1);
  }
  private async handleAdd() {
    if (this.ChangeClaimCode.length === 0) {
      this.$notify({
        title: "提示",
        message: "请选择索赔单据",
        type: "error",
        duration: 2000,
      });
      return;
    }
    let filterData = this.table.list.filter((row) =>
      this.ChangeClaimCode.includes(row.code)
    );
    if (filterData.length > 0) {
      this.$notify({
        title: "提示",
        message:
          filterData.map(function (v) {
            return v.code;
          }) + "已在列表中",
        type: "error",
        duration: 2000,
      });
      return;
    }
    let params = {
      codes: this.ChangeClaimCode
    }
    const res:any = await getClaimDeductionInfo(params)
    this.table.list = [...this.table.list,...res];
    this.table.list.map(e => {
      e.deductionAmountCopy = e.deductionAmountCopy?e.deductionAmountCopy:e.deductionAmount?e.deductionAmount:0
    })
    this.ChangeClaimCode = [];
    (this.$refs["casse"] as any).$refs.panel.checkedValue = [];
    (this.$refs["casse"] as any).$refs.panel.clearCheckedNodes();
    (this.$refs["casse"] as any).$refs.panel.activePath = [];
  }

  private handleChangeClaim(value) {
    if (!value.length) return;
    this.ChangeClaimCode = value;
  }

  public getAmount() {
    const list = this.table.list.filter(item => item.relationDocumentType === "HQ_PACKING_LIST");
    return list.reduce((acc, cur) => acc + cur.deductionAmount, 0);
  }
}
